export default __webpack_public_path__ + "static/media/incentive.1ce9074d.png";